<div class="crm-page container-fluid">
  <div class="page-head">
    <div class="page-head__left">
      <h1 class="page-title">CRM Orçamentos</h1>
      <p class="text-muted">Planeje contatos para leads e acompanhe o calendario.</p>
    </div>
    <div class="page-head__right">
      <button class="btn btn-primary" (click)="openNovoOrcamento()">Novo Orçamento</button>
      <button class="btn btn-primary ms-2" type="button">Importar Excel</button>
    </div>
  </div>

  <div class="panel mb-4">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-6">
        <label class="form-label">Placa do veiculo</label>
        <input class="form-control" [(ngModel)]="filterPlaca" (input)="applyFilters()" />
      </div>
      <div class="col-12 col-md-3">
        <label class="form-label">Status</label>
        <select class="form-select" [(ngModel)]="filterStatus" (change)="applyFilters()">
          <option value="TODOS">Todos</option>
          <option value="Aberto">Aberto</option>
          <option value="Aguardando retorno">Aguardando retorno</option>
          <option value="Efetuar Contato">Efetuar Contato</option>
          <option value="Perdido">Perdido</option>
          <option value="Ganho">Ganho</option>
        </select>
      </div>
      <div class="col-12 col-md-3">
        <div class="text-muted small">Selecione um item para criar contato.</div>
      </div>
    </div>
  </div>

  <div class="crm-tabs">
    <button
      type="button"
      class="crm-tab"
      [class.active]="activeTab === 'board'"
      (click)="setActiveTab('board')"
    >
      Quadro
    </button>
    <button
      type="button"
      class="crm-tab"
      [class.active]="activeTab === 'calendar'"
      (click)="setActiveTab('calendar')"
    >
      Calendário
    </button>
  </div>

  <section class="crm-board" *ngIf="activeTab === 'board'">
    <div class="crm-board__columns" style="max-height: 500px">
      <div class="crm-column" *ngFor="let status of statusColumns">
        <div
          class="crm-column__header"
          [ngStyle]="{ 'background-color': getStatusColor(status) }"
          [ngClass]="getStatusClass(status)"
        >
          <h3 class="crm-column__title">{{ status }}</h3>
          <span class="crm-column__count">{{ getOrcamentosByStatus(status).length }}</span>
        </div>
        <div
          class="crm-column__cards"
          cdkDropList
          [id]="dropListId(status)"
          [cdkDropListData]="getGroupedOrcamentos(status)"
          [cdkDropListConnectedTo]="connectedDropListsIds"
          (cdkDropListDropped)="onDrop($event, status)"
        >
          <button
            type="button"
            class="crm-card"
            *ngFor="let item of getGroupedOrcamentos(status)"
            [ngStyle]="{ 'border-left-color': getStatusColor(status) }"
            (click)="openLeadModal(item)"
            cdkDrag
          >
            <div class="crm-card__row crm-card__row--headline">
              <span class="crm-card__number">{{ formatNumeroOrcamento(item) }}</span>
              <span class="crm-card__value">
                {{ getValor(item) | currency: 'BRL' : 'symbol' : '1.2-2' }}
              </span>
            </div>
            <div class="crm-card__row">
              <span class="crm-card__label">Nome</span>
              <span class="crm-card__value">{{ item.clienteNome }}</span>
            </div>
            <div class="crm-card__row">
              <span class="crm-card__label">Veículo</span>
              <span class="crm-card__value">{{ getVeiculoLabel(item) }}</span>
            </div>
            <div class="crm-card__row">
              <span class="crm-card__label">Consultor</span>
              <span class="crm-card__value">{{ getConsultorNome(item) }}</span>
            </div>
            <div class="crm-card__row">
              <span class="crm-card__label">Abertura</span>
              <span class="crm-card__value">{{ getDataAbertura(item) | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="crm-card__row">
              <span class="crm-card__label">Próximo evento</span>
              <span class="crm-card__value">{{
                getDataProximoEvento(item) | date: 'dd/MM/yyyy'
              }}</span>
            </div>
          </button>
          <div class="crm-column__empty" *ngIf="!getOrcamentosByStatus(status).length">
            Sem orçamentos.
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="crm-cal" *ngIf="activeTab === 'calendar'">
    <div class="panel">
      <div *ngIf="modalAlert" class="alert alert-warning mb-3">{{ modalAlert }}</div>
      <div class="crm-calendar">
        <full-calendar [options]="calendarOptions" [events]="calendarEvents"></full-calendar>
      </div>
    </div>
  </section>
</div>

<div class="modal-backdrop" *ngIf="novoOrcamentoOpen" (click)="closeNovoOrcamento()"></div>
<div class="modal" *ngIf="novoOrcamentoOpen" (click)="closeNovoOrcamento()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h5 class="modal-title">Novo Orçamento</h5>
      <button type="button" class="btn-close" (click)="closeNovoOrcamento()"></button>
    </div>

    <div *ngIf="novoOrcamentoError" class="alert alert-warning mb-3">
      {{ novoOrcamentoError }}
    </div>

    <div class="modal-grid">
      <div class="field-box">
        <div class="field-label">Placa</div>
        <input class="form-control" [(ngModel)]="novoOrcamento.placa" />
      </div>
      <div class="field-box">
        <div class="field-label">Marca</div>
        <input class="form-control" [(ngModel)]="novoOrcamento.marca" />
      </div>
      <div class="field-box">
        <div class="field-label">Modelo</div>
        <input class="form-control" [(ngModel)]="novoOrcamento.modelo" />
      </div>
      <div class="field-box">
        <div class="field-label">Cliente</div>
        <input class="form-control" [(ngModel)]="novoOrcamento.clienteNome" />
      </div>
      <div class="field-box">
        <div class="field-label">Telefone</div>
        <input class="form-control" [(ngModel)]="novoOrcamento.clienteTelefone" />
      </div>
      <div class="field-box">
        <div class="field-label">Email</div>
        <input class="form-control" [(ngModel)]="novoOrcamento.clienteEmail" />
      </div>
      <div class="field-box">
        <div class="field-label">Consultor</div>
        <select class="form-select" [(ngModel)]="novoOrcamento.consultorResponsavel">
          <option *ngFor="let consultor of consultores" [value]="consultor">{{ consultor }}</option>
        </select>
      </div>
      <div class="field-box">
        <div class="field-label">Valor</div>
        <input class="form-control" type="number" [(ngModel)]="novoOrcamento.valor" />
      </div>
    </div>

    <div class="modal-actions">
      <button class="btn btn-muted btn-pill" (click)="closeNovoOrcamento()">Cancelar</button>
      <button class="btn btn-brand btn-pill" (click)="saveNovoOrcamento()">Salvar</button>
    </div>
  </div>
</div>

<div class="modal fade show" *ngIf="showCreateModal" style="display: block">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Novo contato planejado</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Canal</label>
          <select class="form-select" [(ngModel)]="newContato.canal">
            <option value="WHATSAPP">WhatsApp</option>
            <option value="EMAIL">Email</option>
            <option value="LIGACAO">Ligacao</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label">Assunto</label>
          <input class="form-control" [(ngModel)]="newContato.assunto" />
        </div>
        <div class="mb-3">
          <label class="form-label">Observacao</label>
          <textarea class="form-control" rows="3" [(ngModel)]="newContato.observacao"></textarea>
        </div>
        <div class="mb-3">
          <label class="form-label">Data/Hora</label>
          <input
            class="form-control"
            type="datetime-local"
            [ngModel]="newContato.dataHora | date: 'yyyy-MM-ddTHH:mm'"
            (ngModelChange)="onDateInputChange($event)"
          />
        </div>
        <div class="small text-muted" *ngIf="selectedOrcamento">
          Para: {{ selectedOrcamento.placa }} - {{ selectedOrcamento.clienteNome }}
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary btn-pill" (click)="closeModals()">Cancelar</button>
        <button class="btn btn-brand btn-pill" (click)="criarContato()">Salvar</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show wf-modal-backdrop" *ngIf="showCreateModal"></div>

<div class="modal fade show" *ngIf="showEventModal" style="display: block">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Contato planejado</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
      </div>
      <div class="modal-body" *ngIf="selectedEvent">
        <div class="mb-2"><strong>Canal:</strong> {{ selectedEvent.canal }}</div>
        <div class="mb-2"><strong>Assunto:</strong> {{ selectedEvent.assunto }}</div>
        <div class="mb-2">
          <strong>Data:</strong> {{ selectedEvent.dataHora | date: 'dd/MM HH:mm' }}
        </div>
        <div class="mb-2" *ngIf="selectedEvent.observacao">
          <strong>Obs:</strong> {{ selectedEvent.observacao }}
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary btn-pill" (click)="closeModals()">Fechar</button>
        <button class="btn btn-brand btn-pill" (click)="marcarConcluido()">
          Marcar como concluido
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show wf-modal-backdrop" *ngIf="showEventModal"></div>

<app-lead-contato-modal
  [aberto]="leadModalOpen"
  [lead]="selectedLead"
  (fechar)="closeLeadModal()"
  (encerrar)="onLeadEncerrar()"
  (salvar)="onLeadSalvar($event)"
></app-lead-contato-modal>
